export default "__VITE_ASSET__jQxCwT3n__"